class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector('form').addEventListener(
      'input',
      this.debouncedOnSubmit.bind(this),
    );
  }

  connectedCallback() {
    window.addEventListener('scroll', () => {
      const topOffset = this.getBoundingClientRect().top;

      this.classList.toggle('is-sticky', topOffset < 0);
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);

      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCount');
    const container = document.getElementById('ProductCount');

    if (container) {
      container.innerHTML = count ? count.innerHTML : '';
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter',
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const facetsToRenderSelectedValues = Array.from(facetDetailsElements).filter(
      (element) => matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const elem = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      );
      const elemBody = elem.querySelector('[data-filter-body]');
      const selectedValues = elem.querySelector('.js-facets-selected');

      if (elemBody) {
        elemBody.innerHTML = element.querySelector('[data-filter-body]')?.innerHTML;
      }

      if (selectedValues) {
        selectedValues.innerHTML = element.querySelector('.js-facets-selected')?.innerHTML;
      }
    });

    facetsToRenderSelectedValues.forEach((element) => {
      const selectedValuesElement = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"] .js-facets-selected`,
      );
      const newSelectedValues = element.querySelector('.js-facets-selected');

      if (selectedValuesElement && newSelectedValues) {
        selectedValuesElement.innerHTML = newSelectedValues.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest('.js-filter'),
      );
  }

  static renderActiveFacets(html) {
    ['.js-facets-active', '.js-facets-remove-all'].forEach((element) => {
      const htmlElement = html.querySelector(element);
      const hostElement = document.querySelector(element);

      if (!htmlElement || !hostElement) {
        return;
      }

      hostElement.outerHTML = htmlElement.outerHTML;
    });
  }

  static renderCounts(source, target) {
    const selector = '.js-facets-selected';
    const targetElement = target.querySelector(selector);
    const sourceElement = source.querySelector(selector);

    if (sourceElement && targetElement) {
      target.querySelector(selector).outerHTML =
        source.querySelector(selector).outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.querySelector('facet-filters-form').dataset.sectionId,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const target = event.target;
    const context = target.id.includes('desktop') ? 'desktop' : 'mobile';
    const formData = new FormData();
    const targetForm = target.closest('form');
    const formContainer = targetForm.hasAttribute(`data-context="${context}"`) ? targetForm : document.querySelector(`facet-filters-form[data-context="${context}"]`) || targetForm;
    const formDataElements = Array.from(
      formContainer.querySelector('form').elements,
    ).filter(
      (element) => element.id.includes(context),
    );
    for (const element of formDataElements) {
      if (!element.name) continue;
      if (element.type === 'checkbox' || element.type === 'radio') {
        if (element.checked) {
          formData.append(element.name, element.value);
        }
      } else {
        formData.append(element.name, element.value);
      }
    }
    if (target.tagName === 'SELECT' && context === 'desktop') {
      formData.append(target.name, target.value);
    } else if (context === 'desktop') {
      const sortBySelect = document.querySelector('select[id*="desktop"]');

      if (sortBySelect) {
        formData.append(sortBySelect.name, sortBySelect.value);
      }
    }

    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf('?') + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.rangeMin = this.querySelector('input[type="range"]:first-child');
    this.rangeMax = this.querySelector('input[type="range"]:last-child');
    this.inputMin = this.querySelector('input[name="filter.v.price.gte"]');
    this.inputMax = this.querySelector('input[name="filter.v.price.lte"]');

    this.inputMin.addEventListener('focus', this.inputMin.select);
    this.inputMax.addEventListener('focus', this.inputMax.select);
    this.inputMin.addEventListener('change', this.onInputMinChange.bind(this));
    this.inputMax.addEventListener('change', this.onInputMaxChange.bind(this));

    this.rangeMin.addEventListener('change', this.onRangeMinChange.bind(this));
    this.rangeMax.addEventListener('change', this.onRangeMaxChange.bind(this));
    this.rangeMin.addEventListener('input', this.onRangeMinInput.bind(this));
    this.rangeMax.addEventListener('input', this.onRangeMaxInput.bind(this));
  }

  onInputMinChange(event) {
    event.preventDefault();
    event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1), event.target.min);
    this.rangeMin.value = event.target.value;
    this.rangeMin.parentElement.style.setProperty('--range-min', `${parseInt(this.rangeMin.value) / parseInt(this.rangeMin.max) * 100}%`);
  }

  onInputMaxChange(event) {
    event.preventDefault();
    event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1), event.target.max);
    this.rangeMax.value = event.target.value;
    this.rangeMax.parentElement.style.setProperty('--range-max', `${parseInt(this.rangeMax.value) / parseInt(this.rangeMax.max) * 100}%`);
  }

  onRangeMinChange(event) {
    event.stopPropagation();
    this.inputMin.value = event.target.value;
    this.inputMin.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onRangeMaxChange(event) {
    event.stopPropagation();
    this.inputMax.value = event.target.value;
    this.inputMax.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onRangeMinInput(event) {
    event.target.value = Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1);
    event.target.parentElement.style.setProperty('--range-min', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
    this.inputMin.value = event.target.value;
  }

  onRangeMaxInput(event) {
    event.target.value = Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1);
    event.target.parentElement.style.setProperty('--range-max', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
    this.inputMax.value = event.target.value;
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form =
        this.closest('facet-filters-form') ||
        document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetTrigger extends HTMLElement {
  static VISIBLE_CLASS = 'is-visible';

  constructor() {
    super();

    this.toggleVisibleState = this.toggleVisibleState.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.init();
    this.attachEvents();
  }

  disconnectedCallback() {
    this.detachEvents();
  }

  attachEvents() {
    this.currentButton?.addEventListener('click', this.toggleVisibleState);

    this.debouncedResize = debounce(this.onResize, 300);

    window.addEventListener('resize', this.debouncedResize);
  }

  detachEvents() {
   this.currentButton?.removeEventListener('click', this.toggleVisibleState);

   window.removeEventListener('resize', this.debouncedResize);
  }

  init() {
    this.currentButton = this.querySelector('button');
    this.buttons = document.querySelectorAll('facet-trigger button');
    this.forms = document.querySelectorAll('facet-filters-form');
  }

  toggleVisibleState() {
    const isVisible = this.currentButton.classList.contains(FacetTrigger.VISIBLE_CLASS);

    this.forms.forEach(form => form.classList.toggle(FacetTrigger.VISIBLE_CLASS, !isVisible));

    this.buttons.forEach(button => button.classList.toggle(FacetTrigger.VISIBLE_CLASS, !isVisible));

    if (!isVisible) {
      const mobileForm = Array.from(this.forms).find(form => form.getAttribute('data-context') === 'mobile');
      const overflowContainer = mobileForm?.querySelector('[data-overflow]');

      if (!mobileForm || !overflowContainer) {
        return;
      }

      if (!window.matchMedia('(min-width: 750px)').matches) {
        bodyScroll.lock(overflowContainer);
      }
    } else {
      bodyScroll.clear();
    }
  }

  onResize() {
    const mobileForm = Array.from(this.forms).find(form => form.getAttribute('data-context') === 'mobile');
    const isVisible = mobileForm ? mobileForm.classList.contains(FacetTrigger.VISIBLE_CLASS) : false;
    const overflowContainer = mobileForm?.querySelector('[data-overflow]');

    if (!isVisible) {
      return;
    }

    if (window.matchMedia('(min-width: 750px)').matches) {
      bodyScroll.unlock(overflowContainer);
    } else {
      bodyScroll.lock(overflowContainer);
    }
  }
}

customElements.define('facet-trigger', FacetTrigger);
